import { render, staticRenderFns } from "./problemClass.vue?vue&type=template&id=9d014f78&scoped=true"
import script from "./problemClass.vue?vue&type=script&lang=js"
export * from "./problemClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d014f78",
  null
  
)

export default component.exports